<template>
  <div
    class="fc-tab-switcher d-flex align-center"
    :class="{ 'fc-tab-switcher--underline': variant === 'underline' }"
    role="tablist"
    :aria-label="ariaLabel"
    data-testid="fc-tab-switcher"
  >
    <v-btn
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      outlined
      text
      role="tab"
      class="fc-tab-switcher__tab"
      :class="{ 'fc-tab-switcher__tab--active': value === tab.id }"
      :aria-selected="value === tab.id"
      :disabled="disabled"
      :data-testid="`fc-tab-switcher__tab--${tab.id}`"
      @click="onSelect(tab.id)"
    >
      <span class="fc-tab-switcher__label">
        {{ tab.label }}<template v-if="variant === 'underline' && tab.count != null"> ({{ tab.count }})</template>
      </span>
      <span
        v-if="variant !== 'underline' && tab.count != null"
        class="fc-tab-switcher__count"
        data-testid="fc-tab-switcher__count"
      >
        {{ tab.count }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'FcTabSwitcher',

  props: {
    tabs: {
      type: Array,
      default: () => [],
      // { id, label, count? }[]
    },
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: 'Tabs',
    },
    /** `pill` (default) or `underline` for page section tabs */
    variant: {
      type: String,
      default: 'pill',
      validator: (v) => ['pill', 'underline'].includes(v),
    },
  },

  methods: {
    onSelect(id) {
      if (this.disabled || id === this.value) return;
      this.$emit('input', id);
      this.$emit('update:value', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './FcTabSwitcher.scss';
</style>